import { httpClientFormsApi } from './http-client';

export const getPenalties = async (query) => {
  try {
    const response = await httpClientFormsApi.get('api/getallpenalties', {
      params: { query },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching danger products:', error);
    throw error; // Re-throw the error for the caller to handle
  }
};

export const getPenaltyDetails = async (id) => {
  try {
    const response = await httpClientFormsApi.get(`api/getPenaltyDetail/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching danger products:', error);
    throw error; // Re-throw the error for the caller to handle
  }
};
